// ABOUTME: Language helpers over the i18next instance — current language, change, list, stored preference
// ABOUTME: Kept apart from the components so their files export nothing but components

import i18next from "i18next"
import i18n, { LANGUAGE_NAMES, SUPPORTED_LANGUAGES } from "./i18n"
import { STORAGE_KEYS } from "@shared/constants/storageKeys"

export function LangCurrent() {
  return i18next.language || "en"
}

export async function LangChange(lang: string) {
  await i18n.changeLanguage(lang || "ru")
}

export function LangList() {
  // Not the resource store: bundles load per language on demand, so it only knows the languages used so far.
  return [...SUPPORTED_LANGUAGES]
}

export const getLanguage = (): string => i18next.language || (window.localStorage.getItem(STORAGE_KEYS.LANGUAGE) ?? "")

/** The language's own name for a selector option; falls back to the code for anything outside the catalogue. */
export function LangName(code: string) {
  return LANGUAGE_NAMES[code] ?? code
}
